module.exports = __webpack_public_path__ + "static/img/android_iphone.7e199186.png";